import React from "react";
import { Mic } from "lucide-react";
import { Ornament } from "../components/Ornament";

/**
 * DESIGN PREVIEW — Conversation screen, cream/paper variant.
 * Matches the Story Week Day-1 aesthetic exactly.  Static — no logic.
 */
export default function DesignPreviewConversationCream() {
  return (
    <div className="min-h-screen flex flex-col paper" data-testid="preview-conv-cream">
      {/* Top bar */}
      <header className="px-6 py-5 flex items-center justify-between">
        <button className="text-[#8C8278] hover:text-[#111D33] transition p-2 -ml-2" style={{ minHeight: 44, minWidth: 44 }}>
          ✕
        </button>
        <p className="label-ui text-[10px] text-[#B8973A] tracking-[0.35em]">
          A CHILDHOOD SOUND
        </p>
        <div style={{ width: 44 }} />
      </header>

      {/* Big question */}
      <main className="flex-1 flex flex-col items-center justify-center px-6 pb-8">
        <p className="label-ui text-[11px] text-[#B8973A] tracking-[0.3em] text-center mb-6">
          DAY ONE · STORY WEEK
        </p>
        <h1 className="text-center max-w-2xl"
            style={{ fontFamily: "Cormorant Garamond, Georgia, serif", fontWeight: 300,
                     fontSize: "clamp(2.25rem, 7vw, 3.25rem)", lineHeight: 1.15, color: "#111D33" }}>
          Is there a song or piece of music that takes you back to your childhood? What do you remember when you hear it?
        </h1>

        <Ornament className="my-10" color="#B8973A" />

        {/* Ask gently */}
        <div className="w-full max-w-md">
          <p className="label-ui text-[10px] text-[#B8973A] tracking-[0.3em] text-center">ASK GENTLY</p>
          <div className="mt-4 space-y-3 text-center">
            <p className="italic" style={{ fontFamily: "Cormorant Garamond, serif", fontSize: "1.25rem", lineHeight: 1.5, color: "#5C5548" }}>
              Where were you when you first heard it?
            </p>
          </div>
          <button className="mt-5 mx-auto block text-[#B8973A] hover:text-[#8C6A20] transition"
                  style={{ fontFamily: "Georgia, serif", fontSize: "13px", letterSpacing: "0.2em", minHeight: 44 }}>
            Reveal another
          </button>
        </div>
      </main>

      {/* Bottom controls */}
      <footer className="px-6 py-8 flex flex-col items-center gap-5" style={{ background: "#F7F0E0", borderTop: "1px solid #E8D5A3" }}>
        <p className="label-ui text-[24px] tracking-[0.15em]" style={{ color: "#8C6A20", fontFamily: "Georgia, serif" }}>
          00:00
        </p>
        <button className="btn-gold w-full max-w-sm"
                style={{ minHeight: 72, padding: "20px 40px", fontSize: "15px", letterSpacing: "0.3em", display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 12 }}>
          <Mic size={22} /> START RECORDING
        </button>
      </footer>
    </div>
  );
}
